module.exports = __webpack_public_path__ + "static/img/public-sewage-treatment-facility-consulting.761927d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/public-sewage-treatment-facility-consulting.jpg
// module id = 2IGQ
// module chunks = 0